module.exports = __webpack_public_path__ + "static/img/21-2.c0d17a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/21-2.jpg
// module id = 5JQw
// module chunks = 0